import { FormattedMessage } from 'react-intl'
import {
  MobileHeaderSideContainer,
  MobileHeaderTitle,
  MobileViewHeaderContainer
} from '../../styled-component'
import ButtonComponent from '../../../../components/stories/atoms/button'
import {
  buttonSizeOptions,
  buttonVariantOptions
} from '../../../../components/stories/atoms/button/constants'
import { ChevronLeft } from '../../../../components/stories/atoms/icons/essentials'
import { useHistory } from 'react-router-dom'
import { iconSizeOptions } from '../../../../components/stories/atoms/icons/icons-sizes'
import PropTypes from 'prop-types'
import SkeletonComponent from '../../../../components/stories/atoms/skeleton'

const PlanMenuMobileHeader = ({ title, isLoading = false }) => {
  const history = useHistory()

  // handlers
  const handleBackToProjectMenu = () => {
    history.push(`/`)
  }

  return (
    <MobileViewHeaderContainer>
      <MobileHeaderSideContainer>
        <ButtonComponent
          variant={buttonVariantOptions.GHOST}
          size={buttonSizeOptions.SMALL}
          style={{ padding: 0 }}
          onClick={handleBackToProjectMenu}
          disableIconStyle
        >
          <ChevronLeft
            strokeWidth={4}
            size={iconSizeOptions['ICON-XS']}
            style={{ marginRight: '0.25rem' }}
          />
          <FormattedMessage id="projects_projects" />
        </ButtonComponent>
      </MobileHeaderSideContainer>

      <SkeletonComponent
        isLoading={isLoading}
        skeletonShape={{
          height: '23px',
          width: '225px',
          borderRadius: '8px'
        }}
      >
        <MobileHeaderTitle>{title}</MobileHeaderTitle>
      </SkeletonComponent>
      <MobileHeaderSideContainer />
    </MobileViewHeaderContainer>
  )
}

PlanMenuMobileHeader.propTypes = {
  title: PropTypes.string
}

export default PlanMenuMobileHeader
